import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Home, Index } from "../views/home/Home";
import { HomeIndex } from "../views/home/index/view";
import { AccountCustomer } from "../views/account/customer/view";
import { AccountSupplier } from "../views/account/supplier/view";
import { AccountCross } from "../views/account/cross/view";
import { BillCustomer } from "../views/bill/customer/view";
import { BillSupplier } from "../views/bill/supplier/view";
import { BillMonitor } from "../views/bill/monitor/view";
import { BillRechargeLog } from "../views/bill/rechargeLog/view";
import { BillAdjustAmountLog } from "../views/bill/adjustAmountLog/view";
import { InvoiceCollect } from "../views/invoice/collect/InvoiceCollect";
import { InvoiceDraw } from "../views/invoice/draw/InvoiceDraw";
import { BaseApp } from "../views/base/app/view";
import { BaseBe } from "../views/base/be/view";
import { BaseDict } from "../views/base/dict";
import { BaseOrg } from "../views/base/org";
import { BaseSetting } from "../views/base/setting/view";
import { BaseWarehouse } from "../views/base/warehouse/view";
import { BaseCustomer } from "../views/base/customer/view";
import { BaseSupplier } from "../views/base/supplier/view";
import { BaseAcctUnit } from "../views/base/acctUnit/view";
import { BaseAcctUnitDetails } from "../views/base/acctUnit/view/DetailsBox";
import Materiel from "../views/base/materiel/view"//物料管理
import MaterielDetail from "../views/base/materiel/view/materielDetail"//物料管理详情
import { CashPay } from "../views/cash/pay/view";
import { CashCollect } from "../views/cash/collect/view";
import { CustomerAccountDetail } from "../views/account/customer/view/detail";
import { SupplierAccountDetail } from "../views/account/supplier/view/detail";
import { OrganizaShop } from "../views/base/shop/view";

import { AccountCustomer as AccountCustomerManage } from "../views/account/customerManage/view";
import { AccountSupplier as AccountSupplierManage } from "../views/account/supplierManage/view";
import { CustomerAccountDetail as CustomerAccountDetailManage } from "../views/account/customerManage/view/detail";
import { SupplierAccountDetail as SupplierAccountDetailManage } from "../views/account/supplierManage/view/detail";
import { CustomerDiscount } from "../views/account/customerDiscount/view";
import { CustomerDiscountDetail } from "../views/account/customerDiscount/view/DetailsBox";
import { AccountCustomer as AccountCustomerMerge } from "../views/account/customerMerger/view";
import { CustomerMergeDetail as AccountCustomerMergeDetailManage } from "../views/account/customerMerger/view/detail";

//库存管理
import { InventoryStatistics } from "../views/inventory/statistics/view";
import { InventoryStatistic } from "../views/inventory/statistic/view";

import { InventoryReal } from "../views/inventory/real/view";
import { InventoryInterval } from "../views/inventory/interval/view";
import { InternalAccountDetail } from "@/views/account/internal";

// 统计分析
import { StatisticSale } from "@/views/statistics/sale";
import { StatisticPurchase } from "@/views/statistics/purchase";
import { StatisticReceivable } from "@/views/statistics/receivable";
import { StatisticPayable } from "@/views/statistics/payable";
import { BillCreate } from "@/views/bill/create";
import { BillInternal } from "@/views/bill/internal/view";
import { FullOrder } from "@/views/statistics/fullorder/view"

// 供应链
// 销售
import { ScmSaleRoDetails } from "@/views/scmBill/scmSaleRo/view"
import { ScmSaleSoDetails } from "@/views/scmBill/scmSaleSo/view"
// 采购
import { ScmPoDetails } from "@/views/scmBill/scmPurchasePo/view"
import { ScmPurchaseRoDetails } from "@/views/scmBill/scmPurchaseRo/view"

// 云修
// 销售
import { VrmSaleRoDetails } from "@/views/vrmBill/vrmBillSaleRo/view"
import { VrmSaleSoDetails } from "@/views/vrmBill/vrmBillSaleSo/view"
// 采购
import { VrmPoDetails } from "@/views/vrmBill/vrmBillPurchasePo/view"
import { VrmRoDetails } from "@/views/vrmBill/vrmBillPurchaseRo/view"
// 维修工单
import { VrmMaintenanceDetails } from "@/views/vrmBill/vrmBillMaintenance/view"
import { VrmMaintenanceRoDetails } from "@/views/vrmBill/vrmBillMaintenanceRo/view"
import { VrmNewMaintenanceDetails } from "@/views/vrmBill/vrmNewBillmaintenance/view"
import { VrmNewMaintenanceRoDetails } from "@/views/vrmBill/vrmNewBillMaintenanceRo/view"
// 客车
// 销售
import { BmsSaleRoDetails } from "@/views/bmsBill/bmsBillSaleRo/view"
import { BmsSaleSoDetails } from "@/views/bmsBill/bmsBillSaleSo/view"
// 采购
import { BmsRoDetails } from "@/views/bmsBill/bmsBillPurchaseRo/view"
import { BmsPoDetails } from "@/views/bmsBill/bmsBillPurchasePo/view"
// 维修工单
import { BmsMaintenanceDetails } from "@/views/bmsBill/bmsBillmaintenance/view"
// 公交单据
import { BmsBusRoDetails } from "@/views/bmsBill/bmsBillBusRo/view"
import { BmsBusSaleDetails } from "@/views/bmsBill/bmsBillBusSo/view"

import { MonitoringPayment } from "@/views/monitoring/payment/view"
import { MonitoringRemaining } from "@/views/monitoring/remaining/view"

//客户发票
import { InvoiceManage } from "@/views/invoice/manage/view";
import { InvoiceManageDetail } from "@/views/invoice/manage/view/detail";
import { InvoiceManageUpload } from "@/views/invoice/manage/view/detail/upload";
import { InvoiceManageRecord } from "@/views/invoice/manage/view/record";

import ExportRecord from "../views/exportrecord";

//合约管理
import { ContractManage } from "@/views/contract/manage/view/contract";
import { CustomerManage } from "@/views/contract/manage/view/customer";
import { ContractDetail } from "@/views/contract/manage/view/contractDetail";
import { CustomerDetail } from "@/views/contract/manage/view/customerDetail";

//审批流程
import { Approval } from "@/views/approval/view/index";
//加盟商结算账单-订单详情
import { SupplierBillSettle } from "@/views/account/supplierManage/view/detail/settle/total";
import { SupplierBillOrder } from "@/views/account/supplierManage/view/detail/settle/order/detail";

function FmsRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} component={HomeIndex} />
            {/* <Route exact={true} path={"/"} render={() => <Redirect to="/bill/customer" />} /> */}
            {/* <Route exact={true} path={"/"} component={Home} /> */}
            <Route exact={true} path={"/home/index"} component={HomeIndex} />

            <Route exact={true} path={"/account/cross"} component={AccountCross} />
            <Route exact={true} path={"/account/customer"} component={AccountCustomer} />
            <Route exact={true} path={"/account/customer/detail"} component={CustomerAccountDetail} />
            <Route exact={true} path={"/account/supplier"} component={AccountSupplier} />
            <Route exact={true} path={"/account/supplier/detail"} component={SupplierAccountDetail} />

            <Route exact={true} path={'/supplier/settle/bill'} component={SupplierBillSettle} />
            <Route exact={true} path={'/supplier/settle/order'} component={SupplierBillOrder} />

            <Route exact={true} path={"/account/customerManage"} component={AccountCustomerManage} />
            <Route exact={true} path={"/account/customerManage/detail"} component={CustomerAccountDetailManage} />
            <Route exact={true} path={"/account/customerMerger"} component={AccountCustomerMerge} />
            <Route exact={true} path={"/account/customerMerger/detail"} component={AccountCustomerMergeDetailManage} />
            <Route exact={true} path={"/account/supplierManage"} component={AccountSupplierManage} />
            <Route exact={true} path={"/account/supplierManage/detail"} component={SupplierAccountDetailManage} />
            <Route exact={true} path={"/account/customerDiscount"} component={CustomerDiscount} />
            <Route exact={true} path={"/account/customerDiscount/insert"} key="2-5-1" component={CustomerDiscountDetail} />
            <Route exact={true} path={"/account/customerDiscount/edit"} key="2-5-2" component={CustomerDiscountDetail} />
            <Route exact={true} path={"/account/internal/detail"} key="2-6" component={InternalAccountDetail} />



            {/* <Route exact={true} path={"/inventory/statistics"} component={InventoryStatistics} /> */}
            <Route exact={true} path={"/inventory/statistics"} component={InventoryStatistic} />

            <Route exact={true} path={"/inventory/real"} component={InventoryReal} />
            <Route exact={true} path={"/inventory/interval"} component={InventoryInterval} />

            <Route exact={true} path={"/bill/customer"} key="3-1" component={BillCustomer} />
            <Route exact={true} path={"/bill/supplier"} key="3-2" component={BillSupplier} />
            <Route exact={true} path={"/bill/internal"} key="3-3" component={BillInternal} />
            <Route exact={true} path={"/bill/monitor"} key="3-4" component={BillMonitor} />
            <Route exact={true} path={"/bill/rechargeLog"} key="9-6" component={BillRechargeLog} />
            <Route exact={true} path={"/bill/adjustAmountLog"} key="9-7" component={BillAdjustAmountLog} />
            <Route exact={true} path={"/cash/pay"} component={CashPay} />
            <Route exact={true} path={"/cash/collect"} component={CashCollect} />
            <Route exact={true} path={"/invoice/draw"} component={InvoiceDraw} />
            <Route exact={true} path={"/invoice/collect"} component={InvoiceCollect} />
            <Route exact={true} path={"/base/app"} component={BaseApp} />
            <Route exact={true} path={"/base/be"} component={BaseBe} />
            <Route exact={true} path={"/base/dict"} component={BaseDict} />
            <Route exact={true} path={"/base/org"} component={BaseOrg} />
            <Route exact={true} path={"/base/customer"} component={BaseCustomer} />
            <Route exact={true} path={"/base/supplier"} component={BaseSupplier} />
            <Route exact={true} path={"/base/setting"} component={BaseSetting} />
            <Route exact={true} path={"/base/warehouse"} component={BaseWarehouse} />
            <Route exact={true} path={"/base/shop"} component={OrganizaShop} />
            <Route exact={true} path={"/base/materiel"} component={Materiel} />
            <Route exact={true} path={"/base/materiel/insert"} key="8-10-1" component={MaterielDetail} />
            <Route exact={true} path={"/base/materiel/edit"} key="8-10-2" component={MaterielDetail} />
            <Route exact={true} path={"/base/acctUnit"} key="8-11" component={BaseAcctUnit} />
            <Route exact={true} path={"/base/acctUnit/add"} key="8-11-1" component={BaseAcctUnitDetails} />
            <Route exact={true} path={"/base/acctUnit/edit"} key="8-11-2" component={BaseAcctUnitDetails} />

            <Route exact={true} path={"/bill/create"} key="3-3" component={BillCreate} />

            <Route exact={true} path={"/statistic/sale"} key="9-1" component={StatisticSale} />
            <Route exact={true} path={"/statistic/purchase"} key="9-2" component={StatisticPurchase} />
            <Route exact={true} path={"/statistic/receivable"} key="9-3" component={StatisticReceivable} />
            <Route exact={true} path={"/statistic/payable"} key="9-4" component={StatisticPayable} />
            <Route exact={true} path={"/statistic/fullorder"} key="9-5" component={FullOrder} />


            <Route exact={true} path={"/scmBill/scmSaleRo"} key="10-1" component={ScmSaleRoDetails} />
            <Route exact={true} path={"/scmBill/scmSaleSo"} key="10-2" component={ScmSaleSoDetails} />
            <Route exact={true} path={"/scmBill/scmPurchasePo"} key="10-3" component={ScmPoDetails} />
            <Route exact={true} path={"/scmBill/scmPurchaseRo"} key="10-4" component={ScmPurchaseRoDetails} />

            <Route exact={true} path={"/vrmBill/vrmBillSaleRo"} key="11-1" component={VrmSaleRoDetails} />
            <Route exact={true} path={"/vrmBill/vrmBillSaleSo"} key="11-2" component={VrmSaleSoDetails} />
            <Route exact={true} path={"/vrmBill/vrmBillPurchasePo"} key="11-3" component={VrmPoDetails} />
            <Route exact={true} path={"/vrmBill/vrmBillPurchaseRo"} key="11-4" component={VrmRoDetails} />
            <Route exact={true} path={"/vrmBill/vrmBillMaintenance"} key="11-5" component={VrmMaintenanceDetails} />
            <Route exact={true} path={"/vrmBill/vrmBillMaintenanceRo"} key="11-6" component={VrmMaintenanceRoDetails} />
            <Route exact={true} path={"/vrmBill/vrmNewBillMaintenance"} key="11-7" component={VrmNewMaintenanceDetails} />
            <Route exact={true} path={"/vrmBill/vrmNewBillMaintenanceRo"} key="11-8" component={VrmNewMaintenanceRoDetails} />

            <Route exact={true} path={"/bmsBill/bmsBillSaleRo"} key="12-1" component={BmsSaleRoDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillSaleSo"} key="12-2" component={BmsSaleSoDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillPurchasePo"} key="12-3" component={BmsPoDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillPurchaseRo"} key="12-4" component={BmsRoDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillMaintenance"} key="12-5" component={BmsMaintenanceDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillBusRo"} key="12-6" component={BmsBusRoDetails} />
            <Route exact={true} path={"/bmsBill/bmsBillBusSo"} key="12-7" component={BmsBusSaleDetails} />

            <Route exact={true} path={"/monitoring/payment"} key="13-1" component={MonitoringPayment} />
            <Route exact={true} path={"/monitoring/remaining"} key="13-2" component={MonitoringRemaining} />

            <Route exact={true} path={"/invoice/manage"} key="14-1" component={InvoiceManage} />
            <Route exact={true} path={"/invoice/manage/detail"} key="14-1-1" component={InvoiceManageDetail} />
            <Route exact={true} path={"/invoice/manage/detail/upload"} key="14-1-2" component={InvoiceManageUpload} />
            <Route exact={true} path={"/invoice/record"} key="14-2" component={InvoiceManageRecord} />

            <Route exact={true} path={"/exportRecord"} key="15" component={ExportRecord} />

            <Route exact={true} path={"/contract/manage"} key="16-1" component={ContractManage} />
            <Route exact={true} path={"/contract/manage/detail"} key="16-1-1" component={ContractDetail} />
            <Route exact={true} path={"/contract/customer/manage"} key="16-2" component={CustomerManage} />
            <Route exact={true} path={"/contract/customer/detail"} key="16-2-1" component={CustomerDetail} />

            <Route exact={true} path={"/approval"} key="17" component={Approval} />
        </Switch>
    )
}

export default FmsRoute;